/* Pure validation and serialization for the acrylic quote's draft restore flow. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.IDWQuoteRestoreData = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const PRODUCT_ID = '7289473531968';
  const DENOMINATIONS = [10000, 1000, 100, 10, 1];
  const PREFIX = '_quote_edit_';
  const SWITCHES = {adjust:'【入稿データおまかせ調整（無料）】', preview:'【プレビュー画像】'};
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  function fail(code, message) {
    const error = new RangeError(message || code);
    error.code = code;
    error.customerMessage = code === 'QUOTE_NOT_FOUND' ? 'この見積がカートに見つかりません。カートの内容をご確認ください。' : '見積内容を完全に復元できませんでした。カートの見積は変更されていません。';
    throw error;
  }
  function integer(value, min, max, code) {
    if (!Number.isSafeInteger(value) || value < min || value > max) fail(code);
    return value;
  }
  function canonical(value) {
    if (Array.isArray(value)) return '[' + value.map(canonical).join(',') + ']';
    if (value && typeof value === 'object') return '{' + Object.keys(value).sort().map(key => JSON.stringify(key) + ':' + canonical(value[key])).join(',') + '}';
    return JSON.stringify(value);
  }
  function normalizeParts(parts) {
    if (!Array.isArray(parts) || parts.length < 1 || parts.length > 10) fail('INVALID_PARTS');
    return parts.map(part => {
      if (!part || typeof part !== 'object' || Array.isArray(part)) fail('INVALID_PART');
      const widthMm = integer(part.widthMm, 20, 400, 'INVALID_DIMENSION');
      const heightMm = integer(part.heightMm, 20, 400, 'INVALID_DIMENSION');
      if (part.shape === 'circle') {
        const diameterMm = integer(part.diameterMm, 20, 400, 'INVALID_DIMENSION');
        if (widthMm !== diameterMm || heightMm !== diameterMm) fail('INVALID_CIRCLE');
        return {shape:'circle', widthMm, heightMm, diameterMm};
      }
      if (part.shape !== 'standard' && part.shape !== 'rectangle') fail('INVALID_SHAPE');
      return {shape:'standard', widthMm, heightMm};
    });
  }
  function normalizeProperties(properties) {
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) fail('INVALID_PROPERTIES');
    return Object.fromEntries(Object.entries(properties).map(([key, value]) => {
      if (!key || typeof value !== 'string') fail('INVALID_PROPERTY');
      return [key, value];
    }));
  }
  function switchStates(properties) {
    return Object.fromEntries(Object.entries(SWITCHES).map(([name, key]) => {
      if (own(properties, key) && properties[key] !== '' && properties[key] !== '希望する') fail('UNKNOWN_SWITCH_VALUE');
      return [name, properties[key] === '希望する'];
    }));
  }
  function encode(quote, properties) {
    if (!quote || quote.currency !== 'JPY' || typeof quote.version !== 'string' || !quote.version.trim()) fail('INVALID_QUOTE');
    const quantity = integer(quote.quantity, 1, 1000, 'INVALID_QUANTITY');
    const parts = normalizeParts(quote.parts);
    if (quote.partCount !== parts.length) fail('PART_COUNT_MISMATCH');
    integer(quote.totalYen, 1, Number.MAX_SAFE_INTEGER / 100, 'INVALID_TOTAL');
    const state = {v:1, quantity, parts};
    if (properties !== undefined) state.switches = switchStates(normalizeProperties(properties));
    const chars = Array.from(JSON.stringify(state));
    const result = {_quote_edit_v:'1', _quote_edit_count:String(Math.ceil(chars.length / 220))};
    for (let offset = 0; offset < chars.length; offset += 220) result[PREFIX + (offset / 220 + 1)] = chars.slice(offset, offset + 220).join('');
    return result;
  }
  function readableState(properties) {
    const quantityMatch = /^([1-9]\d*)セット（各パーツ([1-9]\d*)個）$/.exec(properties['製作数量'] || '');
    if (!quantityMatch || quantityMatch[1] !== quantityMatch[2]) fail('INVALID_QUANTITY_LABEL');
    const quantity = integer(Number(quantityMatch[1]), 1, 1000, 'INVALID_QUANTITY');
    const keys = Object.keys(properties).filter(key => /^パーツ\d+$/.test(key));
    if (!keys.length || keys.length > 10) fail('INVALID_PARTS');
    const parts = keys.map((_, index) => {
      const value = properties['パーツ' + (index + 1)];
      if (typeof value !== 'string') fail('PART_SEQUENCE');
      let match = /^円形・直径([1-9]\d*)mm$/.exec(value);
      if (match) return {shape:'circle', widthMm:Number(match[1]), heightMm:Number(match[1]), diameterMm:Number(match[1])};
      match = /^横([1-9]\d*)mm\s*×\s*縦([1-9]\d*)mm$/.exec(value);
      if (!match) fail('INVALID_PART_LABEL');
      return {shape:'standard', widthMm:Number(match[1]), heightMm:Number(match[2])};
    });
    return {quantity, parts:normalizeParts(parts)};
  }
  function snapshotState(properties, readable) {
    const snapshotKeys = Object.keys(properties).filter(key => key.startsWith(PREFIX));
    if (!snapshotKeys.length) return {legacy:true, ...readable};
    if (properties._quote_edit_v !== '1' || !/^[1-9]\d*$/.test(properties._quote_edit_count || '')) fail('INVALID_SNAPSHOT_VERSION');
    const count = integer(Number(properties._quote_edit_count), 1, 100, 'INVALID_SNAPSHOT_COUNT');
    if (snapshotKeys.length !== count + 2) fail('SNAPSHOT_CHUNKS');
    const chunks = [];
    for (let index = 1; index <= count; index++) {
      const chunk = properties[PREFIX + index];
      if (typeof chunk !== 'string' || !chunk || Array.from(chunk).length > 220) fail('SNAPSHOT_CHUNKS');
      chunks.push(chunk);
    }
    let state;
    try { state = JSON.parse(chunks.join('')); } catch { fail('SNAPSHOT_JSON'); }
    if (!state || state.v !== 1) fail('INVALID_SNAPSHOT_VERSION');
    const quantity = integer(state.quantity, 1, 1000, 'INVALID_QUANTITY');
    const parts = normalizeParts(state.parts);
    if (quantity !== readable.quantity || canonical(parts) !== canonical(readable.parts)) fail('SNAPSHOT_LABEL_MISMATCH');
    if (state.switches !== undefined && canonical(state.switches) !== canonical(switchStates(properties))) fail('SNAPSHOT_SWITCH_MISMATCH');
    return {legacy:false, quantity, parts};
  }
  function fileURL(value) {
    if (typeof value !== 'string' || /[\s<>"'\\]/.test(value)) return false;
    let url;
    try { url = new URL(value); } catch { return false; }
    if (url.protocol !== 'https:' || url.username || url.password || url.hash || url.port) return false;
    return (url.hostname === 'option.nyc3.digitaloceanspaces.com' && url.pathname.startsWith('/uploads/165461/')) || (url.hostname === 'cdn.shopify.com' && url.pathname.startsWith('/s/files/'));
  }
  function filesFrom(properties) {
    const fields = new Map();
    for (const [key, value] of Object.entries(properties)) {
      const match = /^ファイル([1-9]\d*) (用途|名前|URL)(?:（続き([1-9]\d*)）)?$/.exec(key);
      if (!match) continue;
      if (match[3] && Number(match[3]) < 2) fail('FILE_CHUNK_SEQUENCE');
      const index = integer(Number(match[1]), 1, 100, 'INVALID_FILE_COUNT');
      if (!fields.has(index)) fields.set(index, {});
      const item = fields.get(index);
      if (!item[match[2]]) item[match[2]] = new Map();
      item[match[2]].set(match[3] ? Number(match[3]) : 1, value);
    }
    if (!fields.size) fail('FILES_MISSING');
    function joined(chunks) {
      if (!chunks || !chunks.size) fail('FILE_FIELD_MISSING');
      let value = '';
      for (let index = 1; index <= chunks.size; index++) {
        if (!chunks.has(index)) fail('FILE_CHUNK_SEQUENCE');
        value += chunks.get(index);
      }
      return value;
    }
    const native = Object.entries(properties).filter(([key]) => /^【データ】(?:-[1-9]\d*)?$/.test(key));
    if (native.length !== fields.size) fail('FILE_NATIVE_MISMATCH');
    const used = new Set();
    const files = [];
    for (let index = 1; index <= fields.size; index++) {
      const item = fields.get(index);
      if (!item) fail('FILE_SEQUENCE');
      const name = joined(item['名前']), url = joined(item.URL), label = joined(item['用途']);
      const role = label === '印刷用原稿' ? 'artwork' : label === '穴・差し込みの参考図' ? 'reference' : null;
      if (!name.trim() || !role || !fileURL(url) || used.has(url)) fail('INVALID_FILE');
      const matches = native.filter(([, value]) => value === url);
      if (matches.length !== 1) fail('FILE_NATIVE_MISMATCH');
      used.add(url);
      files.push({name, url, role, nativeKey:matches[0][0]});
    }
    if (!files.some(file => file.role === 'artwork')) fail('ARTWORK_MISSING');
    return files;
  }
  function read(cart, quoteId, variants) {
    if (!cart || !Array.isArray(cart.items)) fail('INVALID_CART');
    if (cart.currency !== undefined && cart.currency !== 'JPY') fail('INVALID_CURRENCY');
    if (typeof quoteId !== 'string' || !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/.test(quoteId)) fail('INVALID_QUOTE_ID');
    const lines = cart.items.filter(item => String(item?.product_id) === PRODUCT_ID && item.properties?._quote_id === quoteId);
    if (!lines.length) fail('QUOTE_NOT_FOUND');
    const properties = normalizeProperties(lines[0].properties);
    const signature = canonical(properties);
    if (typeof properties._quote_version !== 'string' || !properties._quote_version.trim()) fail('QUOTE_VERSION_MISSING');
    if (!/^[1-9]\d*$/.test(properties._quote_total_yen || '')) fail('INVALID_TOTAL');
    const totalYen = integer(Number(properties._quote_total_yen), 1, Math.floor(Number.MAX_SAFE_INTEGER / 100), 'INVALID_TOTAL');
    const denominations = new Set(), lineKeys = new Set();
    let totalCents = 0;
    const variantMap = variants === undefined ? null : new Map();
    if (variantMap) {
      if (!Array.isArray(variants)) fail('INVALID_VARIANTS');
      for (const variant of variants) {
        if (!variant || !DENOMINATIONS.includes(variant.priceYen) || variantMap.has(String(variant.id))) fail('INVALID_VARIANTS');
        variantMap.set(String(variant.id), variant.priceYen);
      }
    }
    for (const line of lines) {
      if (canonical(normalizeProperties(line.properties)) !== signature) fail('QUOTE_PROPERTIES_MISMATCH');
      if (typeof line.key !== 'string' || !line.key.includes(':') || lineKeys.has(line.key)) fail('INVALID_LINE_KEY');
      lineKeys.add(line.key);
      const quantity = integer(line.quantity, 1, 2147483647, 'INVALID_PAYMENT_QUANTITY');
      const originalPrice = integer(line.original_price, 1, Number.MAX_SAFE_INTEGER, 'INVALID_PAYMENT_PRICE');
      const denomination = originalPrice / 100;
      if (!DENOMINATIONS.includes(denomination) || denominations.has(denomination)) fail('INVALID_DENOMINATION');
      denominations.add(denomination);
      if (variantMap && variantMap.get(String(line.variant_id ?? line.id)) !== denomination) fail('PAYMENT_VARIANT_MISMATCH');
      const amount = integer(line.original_line_price, 1, Number.MAX_SAFE_INTEGER, 'INVALID_PAYMENT_AMOUNT');
      if (!Number.isSafeInteger(originalPrice * quantity) || originalPrice * quantity !== amount) fail('PAYMENT_AMOUNT_MISMATCH');
      totalCents += amount;
      if (!Number.isSafeInteger(totalCents)) fail('INVALID_TOTAL');
    }
    if (totalCents !== totalYen * 100) fail('QUOTE_TOTAL_MISMATCH');
    const readable = readableState(properties);
    const expectedSummary = readable.quantity + 'セット・' + readable.parts.length + 'パーツ構成／合計：¥' + totalYen.toLocaleString('ja-JP');
    if (properties['見積内容'] !== expectedSummary) fail('SUMMARY_MISMATCH');
    const state = snapshotState(properties, readable);
    const files = filesFrom(properties);
    const fingerprint = canonical({properties, lines:lines.map(line => [line.key, line.variant_id ?? line.id, line.quantity, line.original_price, line.original_line_price]).sort((a,b) => a[0].localeCompare(b[0]))});
    return {...state, properties, files, quoteId, totalYen, fingerprint};
  }
  return Object.freeze({encode, read, fileURL});
});
